import { CreateBillDto } from "../model/bill/dto/CreateBillDto";
import { getInitialRows } from "./getInitialRows";

export function getInitialDto(): CreateBillDto {
  return {
    billDetails: getInitialRows(),
    invoiceDate: new Date().toISOString().split("T")[0],
    soldTo: "",
    receivedBy: "",
  };
}
